// ModalFeaturedProductItem
import React, { useEffect, useState } from 'react';
import Modal from '../../../components/UI/Modal';
import { useDispatch, useSelector } from 'react-redux';
import { getProducts, updateFeaturedProductItemById } from '../../../actions';
import { createFeaturedProductItem } from '../../../actions';
import AddModal from './AddModal';
import DetailsContent from './DetailsContent';
import RenderProductList from './RenderProductList';

const getId = (value) => {
    if (!value) {
        return "";
    }

    if (typeof value === "object") {
        return value._id || value.id || "";
    }

    return value;
};

const ModalFeaturedProductItem = ({
    updateVisible,
    featuredProductItemObj,
    setTypeModal,
    show,
    handleClose,
    setCurrentId,
    currentId,
    typeModal,
    handleShowModalImg
}) => {
    const dispatch = useDispatch();

    const featuredProductItem = useSelector((state) => (
        currentId
            ? state.featuredProductItem.featuredProductItems?.find((item) => item._id === currentId)
            : null
    ));

    const { products } = useSelector((state) => state.product);

    const [productIds, setProductIds] = useState([]);
    const [filterProductId, setFilterProductId] = useState([]);
    const [updatedProducts, setUpdatedProducts] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState(null);

    const [formFeaturedProduct, setFormFeaturedProduct] = useState({
        name: "",
        description: "",
        type: "main-page-hero",
        scope: "site",
        officeId: "",
    });

    useEffect(() => {
        dispatch(getProducts("createdAtMinus", "0", "500"));
    }, [dispatch]);

    useEffect(() => {
        if (featuredProductItem) {
            setFormFeaturedProduct({
                name: featuredProductItem.name || "",
                description: featuredProductItem.description || "",
                type: featuredProductItem.type || "main-page-hero",
                scope: featuredProductItem.scope || "site",
                officeId: getId(featuredProductItem.officeId),
            });
        }
    }, [featuredProductItem]);

    const clear = () => {
        setCurrentId(null);
        setFormFeaturedProduct({
            name: "",
            description: "",
            type: "main-page-hero",
            scope: "site",
            officeId: "",
        });
        setProductIds([]);
        setFilterProductId([]);
        setUpdatedProducts([]);
        setSelectedProduct(null);
    };

    const handleCloseAndClear = () => {
        handleClose();
        clear();
    };

    const submitContactForm = (e) => {
        if (e && typeof e.preventDefault === "function") {
            e.preventDefault();
        }

        const payload = {
            name: formFeaturedProduct.name,
            type: formFeaturedProduct.type,
            description: formFeaturedProduct.description,
            scope: formFeaturedProduct.scope,
            officeId: formFeaturedProduct.scope === "office" ? formFeaturedProduct.officeId : null,
        };

        if (!payload.name.trim()) {
            return;
        }

        if (!payload.type.trim()) {
            return;
        }

        if (currentId) {
            dispatch(updateFeaturedProductItemById(currentId, payload))
                .then(() => handleCloseAndClear());
            return;
        }

        dispatch(createFeaturedProductItem({
            ...payload,
            products: productIds,
        })).then(() => handleCloseAndClear());
    };

    const filterProduct = () => {
        const currentProducts = featuredProductItemObj?.products || [];

        return products.filter((item) => {
            return !currentProducts.find((product) => {
                const currentProductId = getId(product.productId);
                return currentProductId === item._id;
            });
        });
    };

    const renderEditContent = () => {
        return (
            <div className="featuredProductEdit">
                <AddModal
                    setFormFeaturedProduct={setFormFeaturedProduct}
                    formFeaturedProduct={formFeaturedProduct}
                    setSelectedProduct={setSelectedProduct}
                    selectedProduct={selectedProduct}
                    setProductIds={setProductIds}
                    productIds={productIds}
                    currentId={currentId}
                    products={products}
                />

                {currentId && (
                    <div className="featuredProductEdit__products">
                        <div className="featuredProductEdit__productsHead">
                            <h4>Товары списка</h4>
                            <p>
                                Здесь можно добавить новые товары, удалить уже добавленные и изменить порядок.
                            </p>
                        </div>

                        <RenderProductList
                            hideBackButton
                            featuredProductItemObj={featuredProductItemObj}
                            setUpdatedProducts={setUpdatedProducts}
                            setFilterProductId={setFilterProductId}
                            setSelectedProduct={setSelectedProduct}
                            filterProductId={filterProductId}
                            updatedProducts={updatedProducts}
                            selectedProduct={selectedProduct}
                            itemObj={featuredProductItemObj}
                            setProductIds={setProductIds}
                            setTypeModal={setTypeModal}
                            productIds={productIds}
                            products={products}
                            filterProduct={filterProduct}
                        />
                    </div>
                )}
            </div>
        );
    };

    const renderContentModal = () => {
        let content;
        let title;

        switch (typeModal) {
            case "details":
                content = (
                    <DetailsContent
                        updateVisible={updateVisible}
                        handleShowModalImg={handleShowModalImg}
                        item={featuredProductItemObj}
                        setTypeModal={setTypeModal}
                    />
                );
                title = "Подробная информация";
                break;

            case "detailsProducts":
                content = (
                    <RenderProductList
                        featuredProductItemObj={featuredProductItemObj}
                        setUpdatedProducts={setUpdatedProducts}
                        setFilterProductId={setFilterProductId}
                        setSelectedProduct={setSelectedProduct}
                        filterProductId={filterProductId}
                        updatedProducts={updatedProducts}
                        selectedProduct={selectedProduct}
                        itemObj={featuredProductItemObj}
                        setProductIds={setProductIds}
                        setTypeModal={setTypeModal}
                        productIds={productIds}
                        products={products}
                        filterProduct={filterProduct}
                    />
                );
                title = "Настройка товаров списка";
                break;

            default:
                content = renderEditContent();
                title = currentId ? "Редактировать список" : "Создать список";
        }

        return { content, title };
    };

    const disableVisibleButton = typeModal === "details" || typeModal === "detailsProducts";

    return (
        <Modal
            disabledFunctional={disableVisibleButton}
            modalTitle={renderContentModal().title}
            handleClose={handleCloseAndClear}
            onSubmit={submitContactForm}
            show={show}
        >
            {renderContentModal().content}
        </Modal>
    );
};

export default ModalFeaturedProductItem;